import { render, staticRenderFns } from "./scheduled-content-changes.vue?vue&type=template&id=68532b94&"
import script from "./scheduled-content-changes.vue?vue&type=script&lang=js&"
export * from "./scheduled-content-changes.vue?vue&type=script&lang=js&"
import style0 from "./scheduled-content-changes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports